var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassEyeView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.871 6c0 .547.217 1.071.602 1.458a2.052 2.052 0 002.907 0 2.064 2.064 0 000-2.916 2.052 2.052 0 00-2.907 0c-.385.387-.602.911-.602 1.458zm10.023-.475C14.154 1.85 11.525 0 8 0 4.473 0 1.846 1.85.106 5.527a1.113 1.113 0 000 .948C1.846 10.15 4.475 12 8 12c3.527 0 6.155-1.85 7.894-5.527a1.113 1.113 0 000-.948zM7.927 9.24A3.234 3.234 0 014.697 6a3.234 3.234 0 013.23-3.24c1.783 0 3.23 1.451 3.23 3.24a3.234 3.234 0 01-3.23 3.24z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEyeView);
export default __webpack_public_path__ + "static/media/pass-eye-view.c749d871d01b961c2a1c5c0259a20bd1.svg";
export { ForwardRef as ReactComponent };